import { Direction, OrderBy } from '@generated/schema';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface States {
  listClubhousesEndCursor: string;
  listClubhousesOrderBy: OrderBy;
  listClubhousesPageNumber: number;
  listClubhousesPageSize: number;
  listClubhousesRowIndex: number;
  listClubhousesSearchTerm: string;
}

const initialState: States = {
  listClubhousesEndCursor: '',
  listClubhousesOrderBy: {
    direction: Direction.Desc,
    field: 'createdAt',
  },
  listClubhousesPageNumber: 0,
  listClubhousesPageSize: 10,
  listClubhousesRowIndex: -1,
  listClubhousesSearchTerm: '',
};

export const clubhousesListClubhousesSlice = createSlice({
  initialState,
  name: 'clubhousesListClubhouses',
  reducers: {
    setListClubhousesEndCursor: (state, { payload }: PayloadAction<string>) => {
      state.listClubhousesEndCursor = payload;
    },
    setListClubhousesOrderBy: (state, { payload }: PayloadAction<OrderBy>) => {
      state.listClubhousesOrderBy = payload;
    },
    setListClubhousesPageNumber: (
      state,
      { payload }: PayloadAction<number>,
    ) => {
      state.listClubhousesPageNumber = payload;
    },
    setListClubhousesPageSize: (state, { payload }: PayloadAction<number>) => {
      state.listClubhousesPageSize = payload;
    },
    setListClubhousesRowIndex: (state, { payload }: PayloadAction<number>) => {
      state.listClubhousesRowIndex = payload;
    },
    setListClubhousesSearchTerm: (
      state,
      { payload }: PayloadAction<string>,
    ) => {
      state.listClubhousesSearchTerm = payload;
    },
  },
});

export default clubhousesListClubhousesSlice.reducer;

export const {
  setListClubhousesEndCursor: setListClubhousesEndCursorAction,
  setListClubhousesPageNumber: setListClubhousesPageNumberAction,
  setListClubhousesPageSize: setListClubhousesPageSizeAction,
  setListClubhousesRowIndex: setListClubhousesRowIndexAction,
  setListClubhousesSearchTerm: setListClubhousesSearchTermAction,
} = clubhousesListClubhousesSlice.actions;
